import { inject, Injectable } from '@angular/core';
import { FirebaseWrapperService } from '../firebase-wrapper/firebase-wrapper.service';
import { auditorSimulationKey, continuePathQueryParam, tenantIdQueryParam, tokenQueryParam } from '../../constants';
import { AuthService } from '../auth/auth.service';
import { TenantService } from '../http';
import { firstValueFrom, map } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

@Injectable()
export class AuditorSimulationService {
  private readonly firebaseWrapper = inject(FirebaseWrapperService);
  private readonly authService = inject(AuthService);
  private readonly tenantService = inject(TenantService);

  async redirectToAuditorSimulationPage(frameworkId: string): Promise<void> {
    const token = await firstValueFrom(this.tenantService.createAuditorSimulationToken(frameworkId));
    const tenantId = await firstValueFrom(this.firebaseWrapper.authState().pipe(map((user) => user.tenantId)));

    const queryParams = new URLSearchParams({
      [tokenQueryParam]: token,
      [auditorSimulationKey]: 'true',
      [continuePathQueryParam]: `frameworks/${frameworkId}/controls`,
      [tenantIdQueryParam]: tenantId,
    });

    window.open(`auth/callback?${queryParams.toString()}`, '_blank');
  }

  changeAppAndSetSessionStorageKey(): void {
    const id = uuidv4();

    this.firebaseWrapper.changeApp(`${auditorSimulationKey}-${id}`);
    sessionStorage.setItem(auditorSimulationKey, JSON.stringify(id));
  }

  changeAppIfSessionKeyExists(): void {
    const id = JSON.parse(sessionStorage.getItem(auditorSimulationKey));

    if (id) {
      this.firebaseWrapper.changeApp(`${auditorSimulationKey}-${id}`);
    }
  }

  async removeKeyAndSignOut(): Promise<void> {
    sessionStorage.removeItem(auditorSimulationKey);
    await this.authService.signOutWithoutRedirectAsync(false);
  }
}
